{
  "0154a028a8dc3a3e": "Rules & Expectations",
  "049245ad1f768a37": "Workplace ID",
  "082e2c29db933044": "Connect EMR",
  "09a996ec24fb0a72": "Billing Specialist",
  "09fd2948a8dffd21": "Workplace",
  "0b9e49cf035bd75b": "Interviews",
  "0e199ed6d6f4b783": "Staffing",
  "10104f72c61f60fd": "Workplace Types",
  "11c4c9beeb1da7ae": "Identity Verification",
  "12f67f8539c46701": "Availability",
  "15435b311c937143": "View More",
  "189d145aadfed8e7": "By Period",
  "18fdd549b2ed367a": "New",
  "19766ed6ccb2f4a3": "Cancel",
  "216f411031cbef73": "Workplace Name",
  "2249bd503ec47d72": "Cases",
  "26d6fb4222835ff1": "You will need to sign in again to access your account.",
  "293be5f6b4a34190": "Badge Policy Violations",
  "2bff98865447b479": "24/7 Support",
  "2d7e9dcd95624a2b": "Are you sure you want to log out of all devices?",
  "30a2860742589675": "My Internal Roster",
  "324ddac12d893a7d": "Workplaces",
  "363d6a41a48b73a6": "Post-Invoice Disputes",
  "372330d1b42e8de2": "Shift Explainer",
  "37ae24bdf1c25cd2": "Recently Viewed Accounts",
  "38f01b3c5ffc13e3": "Professional ID",
  "3ac8bbca9a74cfbd": "Billing",
  "3c653dabeef2e3c2": "Shifts",
  "3f9abc8733ba366a": "Navigation menu",
  "3fa7a764f8ffaa77": "Interview Schedule",
  "414aa5b4f7e46da8": "Badge-Strike Reviews",
  "460b3a7da007b7af": "Chat",
  "46bef04d5ef5c857": "Browse help articles and find answers to common questions.",
  "46d51ff0db7eb2e9": "Confirm Log Out",
  "47484938c8a87102": "Reviews Moderation",
  "49c266baaaa70981": "Search",
  "4ab38aa0a0be3888": "Switch to admin",
  "4b4a11d469f69455": "No workplaces available",
  "4c4968ef0a179423": "Visit Help Center",
  "4d5469c7be3b5130": "Bans",
  "4df9939944a7b324": "Placement",
  "4e414af41b7d4876": "Hiring",
  "4e952b41752d7990": "Live Worker ETA",
  "50ce48b9c623c1cd": "Open search",
  "53fe8dfb6d9e1b03": "Payroll",
  "55542efef9055f03": "SSN Worker Lookup",
  "5a639e298037569b": "Clipboard Score",
  "5a79edda3e34d40e": "Logging out…",
  "5c7b8d053d5b3e26": "Shift Logs",
  "5e39688b3981234f": "Timekeeping Videos",
  "63256883cad9b1a5": "Workplace Analytics",
  "65287dcca549e0db": "Permanent Hiring",
  "6b653f745fa52b81": "Refer & Earn",
  "6ccd5c7856042d36": "Close menu",
  "6e2ea637b30eadce": "No records found",
  "6fd553132e7785dc": "Change Log",
  "708e415f9ac11beb": "My Professionals",
  "736a8020568a3133": "Every device signed in to this account will be signed out immediately.",
  "74a883a037bc227f": "Settings",
  "788011833a5a0f22": "Notifications",
  "79e57be0ede1ecb7": "Couldn't log out of all devices. Please try again.",
  "7a1ec9fe6c3b483f": "Workers",
  "7a21f9b68442b295": "Shifts Verification",
  "7b4339cf860e01a6": "Qualifications",
  "8216096dc5263713": "Switch account (current: {{switcherTitle}})",
  "831d0f72d242b7d1": "Getting started",
  "8378c006e5505ccf": "Are you sure you want to log out?",
  "83f74582a922da01": "Shift Search",
  "84cb7871b741c32e": "Reviews",
  "85279245c3c16c92": "Stripe Transfers",
  "881a371729ce67f0": "Timeclocking Settings",
  "8a7c8b67fe8bde8b": "Accounts",
  "8adad8a24dbd0f7b": "Corporate Analytics",
  "8c13bf02a1a2b30e": "Worker Evidences",
  "8f74e5015dd26f64": "Invoice History",
  "904b4af203bd9342": "Workplace Requirements",
  "92b899d39a9f6e5c": "Badge Verification Grading",
  "9474c5cf93f62e30": "No Shows",
  "94c116ee118a7299": "Analytics",
  "95c61170318a2851": "Locations",
  "96d96be238230962": "Candidate Profile",
  "9839593ad1155065": "Currently Viewed",
  "99f2b26bd7057b5b": "Professional Name",
  "9a03073fb5cf415d": "Spend Controls",
  "9ca1816c47234807": "DNR",
  "a29be0c28e95f23f": "Switch workplace",
  "a2e27badeaa364c4": "Log Out From All Devices",
  "a2fb237d15320535": "Upcoming Charges",
  "a78cebc44214256b": "Help Center",
  "a8959c978f05887f": "Search workplaces...",
  "a93cb7c71ee33577": "Landing Page",
  "a9e0e7835ef824a7": "Bulk Workplace Agreements",
  "abefee79c9ed4bb3": "Tap to copy",
  "ac549c250b476176": "Under construction",
  "ac9cde5b5bee03f3": "Coverage Map",
  "ad0187add790ff17": "My Account",
  "af0c3ba6a2ca80ba": "Admin Tools",
  "b1d3c3c3f44d8a16": "Workplace Information",
  "b1fa104b9bf0635e": "Reporting",
  "b40b3713b43dc702": "Open menu",
  "b4e929d8bcfe0418": "Documents",
  "b79cac926e0b2e34": "Help",
  "b832002da297545f": "Invoice",
  "bcc957ee4ec02126": "By Number",
  "be5acd2ec9bc6849": "Contract Terms",
  "c0ebbcb9d9b6e9d3": "Scroll to pending items below",
  "c2c3b55d9c20c18a": "Interview Availability",
  "c5487af5ec0de077": "Search agents or workplaces",
  "c7677b97318f448a": "SMS Portal",
  "c897635c22a67087": "Visit Verification",
  "c8d715a6f56bac25": "Professionals",
  "c9271e487280e152": "No workplaces match \"{{searchTerm}}\"",
  "c98270317b51cbb3": "Employees",
  "ccc498b77ae62cf8": "Account Manager",
  "cdf7ce7d44347fa1": "Other workplaces",
  "cf38d8fe149ecdf8": "Scraping",
  "d065e5b97c6f5a6b": "Load more workplaces",
  "d0ed4b43b56d7470": "Select Account",
  "d159134ea385fdbc": "Application & Jobs",
  "d57d48b71020b33a": "Log Out",
  "d5d0a30b517e3bea": "Calendar",
  "d9e7915f59343c9b": "Browse Professionals",
  "daeb3a9c6c097148": "Corporate Center",
  "db87f5ee3afa1ca9": "Stripe Payouts",
  "dfa9dfa5cad2d8f9": "Eligibility",
  "e0cdd07f6a270b82": "Requirements",
  "e0d1b68224bf0b31": "Current",
  "e2204b3eaff613de": "Team Members",
  "e3373cf04f80ef64": "Pre-Invoice Disputes",
  "e3c8c9b2fc87dc21": "Workplace Rules Quiz",
  "e51248773b9a3f59": "Management",
  "e7d3e769f3f593da": "Administrator",
  "ea61bc15688d1e48": "Copied!",
  "eab19ec694a80bca": "Recently Viewed",
  "ec7ee2826c849564": "Copy details",
  "edad27774d43f2d1": "Calendar (Classic)",
  "ee1b6e3886b4d185": "External Photos",
  "f2b4bd6f9b506e10": "Timeclock Requests",
  "f4830a1dae298044": "Schedule",
  "f4d573798f5b25fe": "Charting",
  "f5b152d912d4a37a": "Browse Talent Pool",
  "f5dc11ce70f8dd27": "Scroll to pending items above",
  "f6120e8981f1882f": "DNRs",
  "f8d47b82e285ba95": "Contact Support",
  "fa00fd7d75c43f54": "Shift Payments",
  "fcc9f1f929785440": "Exclusions",
  "fe01dd4acbf69e7c": "We're currently making improvements to our mobile app. When it's ready, we'll let you know!",
  "ff9c41ba1c875fb1": "Home Health Worker Search"
}
